var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"provision-preview"},[_c('b',[(_vm.data.uid)?_c('span',[_vm._v("uid="+_vm._s(_vm.data.uid))]):_vm._e(),_vm._v(" "),(_vm.data.email)?_c('span',[_vm._v("email="+_vm._s(_vm.email))]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v("\n\t"+_vm._s(_vm.t('mail', 'Domain Match: {provisioningDomain}', { provisioningDomain: _vm.provisioningDomain }))+"\n\t"),_c('br'),_vm._v("\n\t"+_vm._s(_vm.t('mail', 'Email: {email}', { email: _vm.email }))),_c('br'),_vm._v("\n\t"+_vm._s(_vm.t('mail', 'IMAP: {user} on {host}:{port} ({ssl} encryption)', {
			user: _vm.imapUser,
			host: _vm.imapHost,
			port: _vm.imapPort,
			ssl: _vm.imapSslMode,
		}))),_c('br'),_vm._v("\n\t"+_vm._s(_vm.t('mail', 'SMTP: {user} on {host}:{port} ({ssl} encryption)', {
			user: _vm.smtpUser,
			host: _vm.smtpHost,
			port: _vm.smtpPort,
			ssl: _vm.smtpSslMode,
		}))),_c('br'),_vm._v(" "),(_vm.sieveEnabled)?_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.t('mail', 'Sieve: {user} on {host}:{port} ({ssl} encryption)', {
				user: _vm.sieveUser,
				host: _vm.sieveHost,
				port: _vm.sievePort,
				ssl: _vm.sieveSslMode,
			}))),_c('br')]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }